import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbySeo } from 'gatsby-plugin-next-seo';

const SEO = ({ description, meta, title, children }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            social {
              twitter
            }
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description

  return (
    <>
    <GatsbySeo
      title={title}
      description={metaDescription}
      openGraph={{
        title: {title},
        description: {metaDescription},
        images: [{
          url: 'https://www.codeforhumans.info/static/media/learn-cover.9125fcb2.jpg',
          alt: 'Code For Humans cover alt',
        }],
        site_name: site.siteMetadata.title,
      }}
      twitter={{
        handle: site.siteMetadata.social.twitter,
      }}
    />
      {children}
    </>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
